<div class="container-fluid p-0">

  <div class="row mx-auto">

    <!-- Summary + Edit Button -->
    <div class="col-12 d-flex align-items-center p-0">
      <div class="w-100">
        <div class="font-weight-normal text-muted">
          Change your store or brand name here by clicking on 'Edit'. 
          The URL will update to match the new name.
        </div>

        <div class="mt-2 d-flex justify-content-end">
          <button 
            class="btn btn-outline-secondary btn-sm"
            *ngIf="!isEditingSubDomain"
            (click)="onEditClicked()">
            Edit <i class="fa fa-pencil ml-1"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- MAIN FORM -->
    <div [formGroup]="ChangeSellerDomainFrom" class="col-12 mt-3">

      <div class="form-row">

        <!-- Store/Brand Name -->
        <div class="form-group col-md-6">
          <label class="font-weight-bold">Store/Brand Name</label>

          <input 
            type="text" 
            formControlName="subDomainName"
            class="form-control"
            [readonly]="!isEditingSubDomain"
            (input)="onSubdomainChange($event)"
          >

          <div *ngIf="invalidError" class="text-danger small">
            Store Name required
          </div>

          <small 
            *ngIf="ChangeSellerDomainFrom.get('subDomainName')?.hasError('pattern')" 
            class="text-danger"
          >
            Only letters, numbers, and spaces are allowed.
          </small>

          <div 
            *ngIf="ChangeSellerDomainFrom.valid && isSubdomainAvailable && !invalidError" 
            class="text-success small"
          >
            Subdomain is available!
          </div>

          <div 
            *ngIf="ChangeSellerDomainFrom.valid && isSubdomainUnavailable" 
            class="text-danger small"
          >
            Subdomain already exists, please choose another one.
          </div>
        </div>

        <!-- Domain -->
        <div class="form-group col-md-6">
          <label class="font-weight-bold">Domain</label>

          <select 
            class="form-control"
            formControlName="domain"
            [disabled]="!isEditingSubDomain"
            (change)="onDomainChange($event)"
          >
            <option value="" disabled>Select your domain</option>
            <option *ngFor="let d of domainOptions" [value]="d.value">
              {{ d.label }}
            </option>
          </select>

        </div>

      </div>

      <!-- Store URL -->
      <div class="form-group col-12 mt-2 p-0">
        <label class="font-weight-bold">Store URL</label>

        <input 
          type="text" 
          class="form-control"
          [value]="storeUrl"
          readonly
        >
      </div>

    </div>

    <!-- OTP SECTION -->
    <div *ngIf="isShowOtpForm" [formGroup]="OtpForm" class="col-12 mt-3">

      <div class="form-group text-center">

        <label class="font-weight-bold">OTP</label>
        <input formControlName="otp" type="text" class="form-control w-25 mx-auto">

        <div *ngIf="OtpForm.get('otp')?.touched && OtpForm.get('otp')?.errors" class="text-danger small mt-1">
          OTP required
        </div>

        <div class="text-muted mt-2">
          OTP sent to registered mobile number *******{{ lastThreeDigits }}
        </div>

        <div class="mt-2">
          <span class="text-secondary">Didn't receive OTP?</span>

          <span *ngIf="countdown != 0">
            Wait {{ countdown }} seconds
          </span>

          <a 
            class="text-primary"
            role="button"
            *ngIf="countdown == 0"
            (click)="GenerateOtp()"
          >
            Resend OTP
          </a>
        </div>

      </div>

    </div>

    <!-- BUTTONS -->
    <div 
      class="col-12 mt-3 d-flex justify-content-end"
      *ngIf="isEditingSubDomain && !isShowOtpForm"
    >
      <button class="btn btn-danger mr-2" (click)="onCancelClicked()">
        Cancel <i class="fa fa-times ml-1"></i>
      </button>

      <button 
        class="btn btn-primary"
        [disabled]="ChangeSellerDomainFrom.invalid"
        (click)="GenerateOtp()"
      >
        Save <i class="fa fa-save ml-1"></i>
      </button>
    </div>

    <!-- OTP Submit -->
    <div 
      class="col-12 mt-3 d-flex justify-content-end"
      *ngIf="isShowOtpForm"
    >
      <button 
        class="btn btn-primary"
        (click)="onVerifyClicked()"
      >
        Submit <i class="fa fa-save ml-1"></i>
      </button>
    </div>

  </div>

</div>
